import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import { TextAligning } from 'atoms/TextBox'
import {
  TextBoxMaxLine1Sm,
  TextBoxMaxLine5FontXl,
} from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import {
  TextBlock,
  TextBlockAlignItems,
  TextBlockRowGap,
} from 'blocks/TextBlock'

export interface IPopupPINLockHeader extends ITextBlockProps {
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const PopupPINLockHeader = ({
  title,
  description,
  alignItems = TextBlockAlignItems.Center,
  rowGap = TextBlockRowGap.INDENT_20,
  ...rest
}: IPopupPINLockHeader) => {
  return (
    <TextBlock alignItems={alignItems} {...rest} rowGap={rowGap}>
      <TextBoxMaxLine5FontXl title={title} alignment={TextAligning.Center} />
      <TextBoxMaxLine1Sm
        title={description}
        alignment={TextAligning.Center}
        color={Colors.TEXT_ICON_SECONDARY}
      />
    </TextBlock>
  )
}
